import i18n from '../i18n/index.js';

const lang = () => i18n.language || 'pt-BR';

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(lang(), { dateStyle: 'short', timeStyle: 'short' }).format(d);
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '-';
  const d = new Date(iso.length === 10 ? `${iso}T12:00:00Z` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(lang(), { dateStyle: 'medium' }).format(d);
}

export function formatNumber(n: number | null | undefined, digits = 0): string {
  if (n === null || n === undefined) return '-';
  return new Intl.NumberFormat(lang(), { maximumFractionDigits: digits }).format(n);
}

/** Valores grandes compactados (1,2 mil); colunas usam formatNumber. */
export function formatCompact(n: number): string {
  return new Intl.NumberFormat(lang(), { notation: n >= 10_000 ? 'compact' : 'standard', maximumFractionDigits: 1 }).format(n);
}

export function formatPercent(v: number | null | undefined, digits = 1): string {
  if (v === null || v === undefined) return '-';
  return new Intl.NumberFormat(lang(), { style: 'percent', maximumFractionDigits: digits, minimumFractionDigits: digits }).format(v);
}

export function formatDuration(seconds: number): string {
  const d = Math.floor(seconds / 86_400);
  const h = Math.floor((seconds % 86_400) / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  return d ? `${d} d ${h} h` : h ? `${h} h ${m} min` : `${m} min`;
}

/** "a, b, c" -> ["a","b","c"], sem vazios. */
export function splitList(text: string, sep: RegExp = /,/): string[] {
  return text
    .split(sep)
    .map((s) => s.trim())
    .filter(Boolean);
}
